export const OPEN_DRAWER = "navigation/OPEN_DRAWER";
export const CLOSE_DRAWER = "navigation/CLOSE_DRAWER";
export const CHANGE_TITLE = "navigation/CHANGE_TITLE";

const initialState = {
  title: "Zeek Apps",
  isDrawerOpen: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case OPEN_DRAWER:
      return {
        ...state,
        isDrawerOpen: true
      };

    case CLOSE_DRAWER:
      return {
        ...state,
        isDrawerOpen: false
      };

    case CHANGE_TITLE:
      return {
        ...state,
        title: action.title
      };

    default:
      return state;
  }
};

export const openDrawer = () => {
  return dispatch => {
    dispatch({
      type: OPEN_DRAWER
    });
  };
};

export const closeDrawer = () => {
  return dispatch => {
    dispatch({
      type: CLOSE_DRAWER
    });
  };
};

export const changeTitle = title => {
  return dispatch => {
    dispatch({
      type: CHANGE_TITLE,
      title: title
    });
  };
};



// WEBPACK FOOTER //
// ./src/modules/navigation.js